import type {GridColDef} from '@mui/x-data-grid-pro';

/**
 * Grid ignores updated orderedFields because they are passed to initialState,
 * so we force it by sorting columns.
 */
export const orderColumns = (
  columns: GridColDef[],
  orderedFields: string[] | undefined,
): GridColDef[] => {
  if (!orderedFields?.length) {
    return columns;
  }

  const index = new Map(
    orderedFields.map((field, i) => {
      return [field, i];
    }),
  );

  const rank = (field: string) => {
    return index.get(field) ?? Number.MAX_SAFE_INTEGER;
  };

  return [...columns].sort((a, b) => rank(a.field) - rank(b.field));
};
